
const setScrollClass = (scrollY) => {
  const body = document.querySelector('body');
  if (body) {
    if (scrollY > 120) {
      body.classList.add("minimizeBasket");
    } else {
      body.classList.remove("minimizeBasket");
    }
    body.dataset.scroll = scrollY;
  }
};

const checkIframe = () => {
  try {
    return window.top &&
      window.top.document &&
      window.top.document.querySelector('iframe');
  } catch (e) {
    return false;
  }
};

export function scrollToTop() {
  setScrollClass(0);
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, 100);
  if (window.OSPlusNeo &&
    typeof window.OSPlusNeo.scrollTo === "function" &&
    checkIframe()
  ) {
    window.OSPlusNeo.scrollTo(0);
  }
};

export function scrollTo(pos) {
  if (isNaN(pos)) return;
  setScrollClass(pos);
  setTimeout(() => {
    window.scrollTo({ top: pos, left: 0, behavior: "smooth" });
  }, 100);
  if (window.OSPlusNeo &&
    typeof window.OSPlusNeo.scrollTo === "function" &&
    checkIframe()
  ) {
    window.OSPlusNeo.scrollTo(pos);
  }
}
